import React from 'react';
import PropTypes from 'prop-types';
import { appearancePropTypes } from '../utils/appearance';
import styleFactory from './comment-field.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CommentField = props => {
  var handleChange = event => {
    props.onValueChange(event);
  };
  var styles = styleFactory(props.appearance);
  return ___EmotionJSX("div", {
    css: styles.textAreaWrapper
  }, ___EmotionJSX("textarea", {
    cols: "2",
    rows: "2",
    name: "comments",
    value: props.fieldValue,
    onChange: handleChange,
    css: styles.comment,
    placeholder: props.placeholder
  }));
};
CommentField.propTypes = {
  fieldValue: PropTypes.string.isRequired,
  onValueChange: PropTypes.func,
  appearance: appearancePropTypes.isRequired,
  placeholder: PropTypes.string
};
CommentField.defaultProps = {
  onValueChange: () => {},
  placeholder: ''
};
export default CommentField;